__turbopack_context__.v({
  "arrow": "LgnvIG_arrow",
  "item": "LgnvIG_item",
});
